import { DistributionChartParams } from "@/helper/chart/types/distribution-chart.type";
import { doughnutChartConfig } from "@/helper/chart/pie-chart.util";
import { ChartDataPoint } from "./types/chart-data-point.type";
import { chartOptionDefault } from "@/helper/chart/constants/chart-option-default.const";

export const buildDistributionChart = <T extends { count: number }>({
  items,
  options = chartOptionDefault,
  getLabel,
  getColor,
}: DistributionChartParams<T>) => {
  const hasItems = !!items && items.length > 0;

  const colors: string[] = hasItems && items ? items.map((item) => getColor(item)) : [];
  let chartData: ChartDataPoint[] = [];

  let total = 0;
  if (hasItems && items) {
    total = items.reduce((result, item) => result + item.count, 0);
  }
  if (hasItems && items && total > 0) {
    // Populate chartData with percentage values when we have items and a non-zero total
    chartData = items.map((item) => ({
      name: getLabel(item),
      value: (item.count * 100) / total,
    }));
  }

  const chartConfig = doughnutChartConfig({ variant: "secondary", barColors: colors });
  const showLabel = options.title?.showLabel ?? chartOptionDefault.title.showLabel;

  return {
    ...chartConfig,
    title: { ...chartConfig.title, ...options.title },
    tooltip: {
      ...chartConfig.tooltip,
      formatter: (p: { marker: string; name: string; value: number }) =>
        `${p.marker} ${p.name}: <b>${Math.round(p.value)}%</b>`,
    },
    legend: {
      ...chartConfig.legend,
      formatter: (name: string) => {
        const it = chartData.find((d) => d.name === name) || { value: 0 };
        return `{name|${name}}\n{val|${Math.round(it.value)}%}`;
      },
      data: chartData.map((d) => d.name),
      type: "scroll",
    },
    series: chartConfig.series.map((s) => ({
      ...s,
      data: chartData,
      label: {
        ...s.label,
        show: showLabel,
      },
    })),
  };
};
